var map = {
	"./svg/AToZSVG.jsx": 71309,
	"./svg/AccessViewContainerSVG.jsx": 4909,
	"./svg/AccessViewSVG.jsx": 49336,
	"./svg/ActivateMemberSVG.jsx": 20904,
	"./svg/ActivateTmSVG.jsx": 95488,
	"./svg/ActivatedSVG.jsx": 62656,
	"./svg/AddAccessViewSVG.jsx": 26570,
	"./svg/AddAnotherMemberSVG.jsx": 92877,
	"./svg/AddCarretRightSVG.jsx": 45583,
	"./svg/AddColumnLeftSVG.jsx": 67957,
	"./svg/AddColumnRightSVG.jsx": 98356,
	"./svg/AddColumnSVG.jsx": 84848,
	"./svg/AddCommentSVG.jsx": 67603,
	"./svg/AddIconLQASVG.jsx": 95277,
	"./svg/AddIconSVG.jsx": 6155,
	"./svg/AddIconSVGFilled.jsx": 19790,
	"./svg/AddRecordAboveSVG.jsx": 31289,
	"./svg/AddRowBelowSVG.jsx": 3649,
	"./svg/AddUserViewSVG.jsx": 14544,
	"./svg/AddWorkspaceSVG.jsx": 68897,
	"./svg/AddonSVG.jsx": 62400,
	"./svg/AnchorLeft.jsx": 23197,
	"./svg/ApiStatusSVG.jsx": 91372,
	"./svg/ApplyIconSVG.jsx": 42309,
	"./svg/ArrowBackSVG.jsx": 60925,
	"./svg/ArrowDownSVG.jsx": 78678,
	"./svg/ArrowKeyDownSVG.jsx": 4035,
	"./svg/ArrowKeyUpSVG.jsx": 79100,
	"./svg/ArrowLeft2SVG.jsx": 5590,
	"./svg/ArrowLeftSVG.jsx": 52083,
	"./svg/ArrowMoveDownSVG.jsx": 78490,
	"./svg/ArrowMoveUpSVG.jsx": 30138,
	"./svg/ArrowNextSVG.jsx": 37660,
	"./svg/ArrowRightSVG.jsx": 14164,
	"./svg/ArrowUpSVG.jsx": 53761,
	"./svg/AudioNextSVG.jsx": 95846,
	"./svg/AudioPlaySVG.jsx": 18308,
	"./svg/AudioPrevSVG.jsx": 6812,
	"./svg/AudioSongSVG.jsx": 66864,
	"./svg/AuthyAuthSVG.jsx": 90588,
	"./svg/AutoQASVG.jsx": 45092,
	"./svg/AutoQASVG2.jsx": 26202,
	"./svg/AutomationTriggerSVG.jsx": 20765,
	"./svg/AvatarIconSVG.jsx": 71235,
	"./svg/BackButtonSVG.jsx": 50404,
	"./svg/BackIOSSVG.jsx": 83792,
	"./svg/BackgroundLoginSVG.jsx": 94173,
	"./svg/BlockQuoteSVG.jsx": 32452,
	"./svg/BoldSVG.jsx": 98969,
	"./svg/BranchSVG.jsx": 62734,
	"./svg/BugIconSVG.jsx": 74858,
	"./svg/BulletList.jsx": 49635,
	"./svg/CannotEditSVG.jsx": 14853,
	"./svg/CaseSensitiveSVG.jsx": 31821,
	"./svg/CellDiffSVG.jsx": 99868,
	"./svg/CellPreviewSVG.jsx": 57851,
	"./svg/ChairSVG.jsx": 79193,
	"./svg/ChatSVG.jsx": 25691,
	"./svg/CheckIconSVG.jsx": 30092,
	"./svg/CheckedBoolean.jsx": 10733,
	"./svg/CheckedContainerSVG.jsx": 4267,
	"./svg/CheckedSVG.jsx": 75337,
	"./svg/ChromeNotifySVG.jsx": 10454,
	"./svg/CircleAddIconSVG.jsx": 37062,
	"./svg/CircleCheckSVG.jsx": 20855,
	"./svg/CleanSVG.jsx": 32350,
	"./svg/CloseFolderSVG.jsx": 64109,
	"./svg/CloseIconSVG.jsx": 67444,
	"./svg/CloudsSVG.jsx": 81894,
	"./svg/CodeSVG.jsx": 15428,
	"./svg/CodingSVG.jsx": 77091,
	"./svg/ColorAddSVG.jsx": 13223,
	"./svg/ColorBucketSVG.jsx": 35360,
	"./svg/ColorCloseCircleSVG.jsx": 45211,
	"./svg/ColorCloseSVG.jsx": 58536,
	"./svg/ColorStickerSVG.jsx": 31846,
	"./svg/ColumnPermissionSVG.jsx": 52450,
	"./svg/ComingSoonSVG.jsx": 64890,
	"./svg/CommentEmojiIconSVG.jsx": 15945,
	"./svg/CommentNotFoundSVG.jsx": 82754,
	"./svg/CommentNotifySVG.jsx": 61051,
	"./svg/CommentReOpenSVG.jsx": 63435,
	"./svg/CommentResolvedSVG.jsx": 43700,
	"./svg/CommentsSVG.jsx": 52488,
	"./svg/CompanyGroupTutorialSVG.jsx": 75924,
	"./svg/CompanySVG.jsx": 95272,
	"./svg/ConnectorSVG.jsx": 5256,
	"./svg/ConnectorSidebarSVG.jsx": 94065,
	"./svg/CopySourceSVG.jsx": 86198,
	"./svg/CustomSVG.jsx": 6710,
	"./svg/DatabaseEmptySVG.jsx": 85347,
	"./svg/DatabaseSVG.jsx": 94517,
	"./svg/DeactivateMemberSVG.jsx": 10787,
	"./svg/DeactivateTmSVG.jsx": 18921,
	"./svg/DefaultSystemItemSVG.jsx": 85527,
	"./svg/DeleteAvailableRecordSVG.jsx": 9564,
	"./svg/DeleteSVG.jsx": 84183,
	"./svg/DependencySVG.jsx": 13208,
	"./svg/DoneSVG.jsx": 33154,
	"./svg/DownloadSVG.jsx": 27777,
	"./svg/DraggingSVG.jsx": 6636,
	"./svg/DropdownSVG.jsx": 58938,
	"./svg/DuplicateSVG.jsx": 54917,
	"./svg/EditGroupSVG.jsx": 71478,
	"./svg/EditPaperSVG.jsx": 4394,
	"./svg/EditSVG.jsx": 51542,
	"./svg/ElsaSVG.jsx": 23277,
	"./svg/EmptyBoxSVG.jsx": 3236,
	"./svg/EmptyGridSVG.jsx": 16499,
	"./svg/EmptyGroupAccessSVG.jsx": 99425,
	"./svg/EmptyGroupMembersSVG.jsx": 98590,
	"./svg/ErrorIconSVG.jsx": 53081,
	"./svg/ErrorSVG.jsx": 63363,
	"./svg/ExcelSVG.jsx": 88163,
	"./svg/ExclaimationMarkSVG.jsx": 3392,
	"./svg/ExpandRecordSVG.jsx": 40700,
	"./svg/ExpandSVG.jsx": 73932,
	"./svg/ExportJsonSVG.jsx": 96162,
	"./svg/ExportSVG.jsx": 10513,
	"./svg/ExtendViewSVG.jsx": 94329,
	"./svg/EyeCloseIconSVG.jsx": 20665,
	"./svg/EyeOpenIconSVG.jsx": 90481,
	"./svg/FileSVG.jsx": 64652,
	"./svg/FillStarSVG.jsx": 55288,
	"./svg/FilterSVG.jsx": 58143,
	"./svg/FlightSVG.jsx": 80998,
	"./svg/FolderUploadSVG.jsx": 49749,
	"./svg/FormulaSVG.jsx": 83480,
	"./svg/FreeTrialBannerSVG.jsx": 29097,
	"./svg/FullAPIDocSVG.jsx": 45533,
	"./svg/GeneralSettingSVG.jsx": 35478,
	"./svg/GetStartedBkgSVG.jsx": 68390,
	"./svg/GlobalUniqueRecordIdSVG.jsx": 60735,
	"./svg/GoogleAuthSVG.jsx": 31416,
	"./svg/GoogleCalendarSVG.jsx": 20102,
	"./svg/GoogleLoginSVG.jsx": 68031,
	"./svg/GoogleSheetSVG.jsx": 30723,
	"./svg/GridContainerSVG.jsx": 84780,
	"./svg/GridIconSVG.jsx": 53622,
	"./svg/GridListEmptySVG.jsx": 49624,
	"./svg/GridSVG.jsx": 76902,
	"./svg/GridTMSVG.jsx": 74493,
	"./svg/GridTablePreviewSVG.jsx": 47794,
	"./svg/H1IconSVG.jsx": 10482,
	"./svg/H2IconSVG.jsx": 74555,
	"./svg/H3IconSVG.jsx": 34562,
	"./svg/HambergerMenuSVG.jsx": 29830,
	"./svg/HashSymbolSVG.jsx": 53893,
	"./svg/HelpCircleSVG.jsx": 87188,
	"./svg/HelpSVG.jsx": 90761,
	"./svg/HelpSquareSVG.jsx": 46587,
	"./svg/HistorySVG.jsx": 4861,
	"./svg/HistorySVG2.jsx": 80713,
	"./svg/IconAddMemberSVG.jsx": 26933,
	"./svg/IconAdminUserSVG.jsx": 94176,
	"./svg/IconCameraSVG.jsx": 80790,
	"./svg/IconCaretDownSVG.jsx": 31604,
	"./svg/IconCaretRightSVG.jsx": 60739,
	"./svg/IconCopySVG.jsx": 71025,
	"./svg/IconDirectionRightSVG.jsx": 56804,
	"./svg/IconFullAccessSVG.jsx": 3699,
	"./svg/IconGridlySVG.jsx": 27707,
	"./svg/IconImageSVG.jsx": 8825,
	"./svg/IconLimitAccessSVG.jsx": 60858,
	"./svg/IconListSVG.jsx": 94704,
	"./svg/IconLockSVG.jsx": 61270,
	"./svg/IconMoreActionsSVG.jsx": 24184,
	"./svg/IconTMSettingSVG.jsx": 31714,
	"./svg/IconTMXFileSVG.jsx": 12176,
	"./svg/IconTableSVG.jsx": 29664,
	"./svg/IconUploadFileSVG.jsx": 25403,
	"./svg/IdentifySVG.jsx": 32146,
	"./svg/IgnoreSameSVG.jsx": 99702,
	"./svg/IgnoreSingleSVG.jsx": 22987,
	"./svg/ImageSlideShowSVG.jsx": 91943,
	"./svg/ImportFileSVG.jsx": 84566,
	"./svg/ImportSVG.jsx": 68967,
	"./svg/InfoContainedIconSVG.jsx": 70232,
	"./svg/InfoIconSVG.jsx": 96635,
	"./svg/InternalManagerSVG.jsx": 65281,
	"./svg/InternalUserSVG.jsx": 96189,
	"./svg/InviteCompanySVG.jsx": 66734,
	"./svg/InviteMemberSuccessSVG.jsx": 35639,
	"./svg/ItalicSVG.jsx": 83376,
	"./svg/JsonFileSVG.jsx": 85614,
	"./svg/KeyboardSVG.jsx": 18976,
	"./svg/KickoutSVG.jsx": 48412,
	"./svg/LQAContainerSVG.jsx": 51797,
	"./svg/LQAIconSVG.jsx": 54851,
	"./svg/LQAIssueTypeSVG.jsx": 40317,
	"./svg/LQASVG.jsx": 39600,
	"./svg/LQASettingSVG.jsx": 54420,
	"./svg/LQAStatusChangeSVG.jsx": 20097,
	"./svg/LQAViewSVG.jsx": 37287,
	"./svg/LambdaSVG.jsx": 35510,
	"./svg/LeftBushSVG.jsx": 46982,
	"./svg/LicenseSVG.jsx": 71301,
	"./svg/LinkIconSVG.jsx": 85643,
	"./svg/LinkSVG copy.jsx": 99428,
	"./svg/LinkSVG.jsx": 2017,
	"./svg/LoadingMonsterSVG.jsx": 81911,
	"./svg/LogoGridUISVG.jsx": 99625,
	"./svg/LogoGridlySVG.jsx": 99250,
	"./svg/LogoutSVG.jsx": 24555,
	"./svg/MagicWandSVG.jsx": 75775,
	"./svg/MailgunSVG.jsx": 70353,
	"./svg/MaintenanceSVG.jsx": 62098,
	"./svg/MediumSVG.jsx": 1441,
	"./svg/MemsourceSVG.jsx": 16412,
	"./svg/MicrosoftAuthSVG.jsx": 85098,
	"./svg/MultiStepIllustratorSVG.jsx": 95856,
	"./svg/MultipleRowSVG.jsx": 84262,
	"./svg/MySqlSVG.jsx": 66283,
	"./svg/NewTMSVG.jsx": 96227,
	"./svg/NewVersionNotifySVG.jsx": 47983,
	"./svg/NextButtonSVG.jsx": 59696,
	"./svg/NoAccessSVG.jsx": 88718,
	"./svg/NoPathTagSVG.jsx": 67069,
	"./svg/NoShareViewGroupSVG.jsx": 46275,
	"./svg/NoSourceIllustratorSVG.jsx": 80118,
	"./svg/NoTranslationOverviewSVG.jsx": 70933,
	"./svg/NoTreeItemSVG.jsx": 48464,
	"./svg/NonBreakingSpaceSVG.jsx": 71786,
	"./svg/NormalFIlterModeSVG.jsx": 93173,
	"./svg/NormalSortSVG.jsx": 14293,
	"./svg/NotFoundBoxSVG.jsx": 46763,
	"./svg/NotFoundIllustrationSVG.jsx": 25397,
	"./svg/NotificationSVG.jsx": 62466,
	"./svg/NumberList.jsx": 3162,
	"./svg/OpenFolderSVG.jsx": 49414,
	"./svg/OpenNewPageSVG.jsx": 59789,
	"./svg/OrganizationSetttingSVG.jsx": 50328,
	"./svg/OutlineStarSVG.jsx": 3630,
	"./svg/ParagraphSVG.jsx": 60831,
	"./svg/PartialCheckedBoolean.jsx": 20783,
	"./svg/PathTagSVG.jsx": 39750,
	"./svg/PauseContained2SVG.jsx": 70339,
	"./svg/PauseContainedSVG.jsx": 12159,
	"./svg/PauseSVG.jsx": 84280,
	"./svg/PercentageSymbolSVG.jsx": 83633,
	"./svg/PinSVG.jsx": 29131,
	"./svg/PlayCircleSVG.jsx": 4515,
	"./svg/PlayContainedSVG.jsx": 68271,
	"./svg/PlayOutlinedSVG.jsx": 85540,
	"./svg/PlaySVG.jsx": 18520,
	"./svg/PostgresSVG.jsx": 5052,
	"./svg/PreviewCellSVG.jsx": 63959,
	"./svg/PreviewSVG.jsx": 76896,
	"./svg/PrivacyPolicySVG.jsx": 23221,
	"./svg/ProjectAboutSVG.jsx": 44882,
	"./svg/ProjectMemberSVG.jsx": 6323,
	"./svg/ProjectUsageSVG.jsx": 19857,
	"./svg/QuestionSVG.jsx": 96425,
	"./svg/QuickApplyTmSVG.jsx": 4737,
	"./svg/QuickFilterSVG.jsx": 69853,
	"./svg/RecordPanelEmptyRecordSVG.jsx": 25103,
	"./svg/RedoSVG.jsx": 75626,
	"./svg/RefreshSVG.jsx": 44344,
	"./svg/RegexSVG.jsx": 49934,
	"./svg/RemoveSVG.jsx": 27910,
	"./svg/RemoveTagSVG.jsx": 42112,
	"./svg/RepeatSVG.jsx": 95829,
	"./svg/ReplaceSVG.jsx": 21649,
	"./svg/ResendInvitationSVG.jsx": 23287,
	"./svg/RevertSVG.jsx": 29472,
	"./svg/RevokeSVG.jsx": 75354,
	"./svg/RowHeightSVG.jsx": 97609,
	"./svg/SamlLoginSVG.jsx": 32633,
	"./svg/SaveSVG.jsx": 45742,
	"./svg/SearchSVG.jsx": 30130,
	"./svg/SecuritySVG.jsx": 47305,
	"./svg/SendCommentSVG.jsx": 7604,
	"./svg/SettingBillingSVG.jsx": 6750,
	"./svg/SettingGroupSVG.jsx": 8197,
	"./svg/SettingInfoSVG.jsx": 23148,
	"./svg/SettingMemberSVG.jsx": 29158,
	"./svg/SettingPaymentSVG.jsx": 29200,
	"./svg/SettingRoleSVG.jsx": 49194,
	"./svg/SettingSVG.jsx": 10143,
	"./svg/SettingStatisticSVG.jsx": 80686,
	"./svg/ShareLinkOptionSVG.jsx": 66282,
	"./svg/ShareLinkViewIlluSVG.jsx": 77010,
	"./svg/ShareSVG.jsx": 80862,
	"./svg/SharedUserViewSVG.jsx": 38481,
	"./svg/ShieldSVG.jsx": 32729,
	"./svg/ShortSVG.jsx": 52732,
	"./svg/ShowAllConflictsSVG.jsx": 9826,
	"./svg/ShowSpecialCharacterSVG.jsx": 2839,
	"./svg/ShuffleSVG.jsx": 1147,
	"./svg/SinglePathTagSVG.jsx": 79512,
	"./svg/SingleRowSVG.jsx": 65989,
	"./svg/SleepBellSVG.jsx": 14449,
	"./svg/SmileFaceSVG.jsx": 59120,
	"./svg/SortAscendingSVG.jsx": 15163,
	"./svg/SortDescendingSVG.jsx": 85541,
	"./svg/SortFilterSVG.jsx": 40183,
	"./svg/SpeakerSVG.jsx": 86703,
	"./svg/SrSpSVG.jsx": 16656,
	"./svg/StrikethroughSVG.jsx": 28893,
	"./svg/SubtractSVG.jsx": 81573,
	"./svg/SuccessIconSVG.jsx": 19276,
	"./svg/SupportAgentSVG.jsx": 28835,
	"./svg/SwapSVG.jsx": 91507,
	"./svg/SwitchIconSVG.jsx": 21989,
	"./svg/SwitchSVG.jsx": 77686,
	"./svg/Sync2SVG.jsx": 67104,
	"./svg/SyncConnectionIllustratorSVG.jsx": 41195,
	"./svg/SyncSVG.jsx": 47598,
	"./svg/SynchronizeTMColorSVG.jsx": 67454,
	"./svg/SynchronizeTMPullSVG.jsx": 91955,
	"./svg/SynchronizeTMPushSVG.jsx": 63200,
	"./svg/SynchronizeTMSVG.jsx": 89542,
	"./svg/SystemGroupSVG.jsx": 75755,
	"./svg/TBIconSVG.jsx": 42634,
	"./svg/TBSettingSVG.jsx": 80840,
	"./svg/TMGuideSVG.jsx": 4314,
	"./svg/TMIconSVG.jsx": 65933,
	"./svg/TMSVG.jsx": 58369,
	"./svg/TMSearchNotFoundSVG.jsx": 49032,
	"./svg/TMSettingSVG.jsx": 4804,
	"./svg/TagSVG.jsx": 82600,
	"./svg/TallSVG.jsx": 46514,
	"./svg/TemplateSVG.jsx": 55103,
	"./svg/TextColorSVG.jsx": 90019,
	"./svg/TextSVG.jsx": 69638,
	"./svg/TransferInternalSVG.jsx": 26438,
	"./svg/TransformOwnerShipSVG.jsx": 44993,
	"./svg/TransformSVG.jsx": 48943,
	"./svg/TranslationMemorySVG.jsx": 2644,
	"./svg/TutorialSVG.jsx": 70198,
	"./svg/UnCheckSVG.jsx": 36356,
	"./svg/UncheckedBoolean.jsx": 31202,
	"./svg/UnderlineSVG.jsx": 28710,
	"./svg/UndoSVG.jsx": 11477,
	"./svg/UniquePathtagRecordIdSVG.jsx": 41974,
	"./svg/UnstableSVG.jsx": 63616,
	"./svg/UpdateIconSVG.jsx": 44118,
	"./svg/UpdateJsonSVG.jsx": 59599,
	"./svg/UploadFileSVG.jsx": 64038,
	"./svg/UploadFromCloudSVG.jsx": 31498,
	"./svg/UploadingDoneSVG.jsx": 71483,
	"./svg/UploadingErrorSVG.jsx": 8241,
	"./svg/UserIconSVG.jsx": 9120,
	"./svg/UserPlusSVG.jsx": 15525,
	"./svg/UserViewSVG.jsx": 52139,
	"./svg/VideoPlaySVG.jsx": 24048,
	"./svg/WarningRoundSVG.jsx": 26837,
	"./svg/WarningSVG.jsx": 823,
	"./svg/WarningSwitchingColumnSVG.jsx": 79718,
	"./svg/WelcomeBoySVG.jsx": 98478,
	"./svg/WelcomeGirlSVG.jsx": 4093,
	"./svg/WelcomeIconSVG.jsx": 72617,
	"./svg/WelcomePlaySVG.jsx": 12691,
	"./svg/WhatNewSVG.jsx": 51859,
	"./svg/WorkspaceEmptySVG.jsx": 94926,
	"./svg/WorkspaceSVG.jsx": 72124,
	"./svg/WraptextSVG.jsx": 2619,
	"./svg/YAYSVG.jsx": 39481,
	"./svg/ZToASVG.jsx": 8846,
	"./svg/ZapierSVG.jsx": 66954,
	"./svg/addon/AddButtonContainerSVG.jsx": 90680,
	"./svg/addon/AutomationActionSVG.jsx": 99245,
	"./svg/addon/CurrentLQASVG.jsx": 20355,
	"./svg/addon/GridlyShortLogoSVG.jsx": 1577,
	"./svg/addon/LQASVG.jsx": 25670,
	"./svg/addon/LQAStep2SVG.jsx": 30848,
	"./svg/addon/MemSourceGridlySVG.jsx": 79265,
	"./svg/addon/MemSourceSVG.jsx": 91333,
	"./svg/addon/MemoQGridlySVG.jsx": 20613,
	"./svg/addon/MemoQSVG.jsx": 98816,
	"./svg/addon/NoFoundSVG.jsx": 40335,
	"./svg/addon/SettingSVG.jsx": 93229,
	"./svg/addon/TranslationOverviewSVG.jsx": 93300,
	"./svg/apiKeys/FullAccessSVG.jsx": 73791,
	"./svg/apiKeys/NotFoundSVG.jsx": 26506,
	"./svg/apiKeys/PartialAccessSVG.jsx": 73666,
	"./svg/backup/NoBackupFileSVG.jsx": 49798,
	"./svg/censors/VersionControlLightSVG.jsx": 14970,
	"./svg/censors/VersionControlSVG.jsx": 86805,
	"./svg/dependencies/ApproveSVG.jsx": 91079,
	"./svg/dependencies/SourceStatusSVG.jsx": 87353,
	"./svg/dependencies/StringTypeSVG.jsx": 43920,
	"./svg/dependencies/column/normal/DoNotTranslateSVG.jsx": 76782,
	"./svg/dependencies/column/normal/EmptySVG.jsx": 64238,
	"./svg/dependencies/column/normal/LockedSVG.jsx": 9588,
	"./svg/dependencies/column/normal/NotReadyForTranslateSVG.jsx": 15849,
	"./svg/dependencies/column/normal/ReadyForTranslateSVG.jsx": 99744,
	"./svg/diff/Minus.jsx": 42109,
	"./svg/diff/Plus.jsx": 72156,
	"./svg/extendViews/Large.jsx": 62612,
	"./svg/extendViews/Medium.jsx": 18097,
	"./svg/extendViews/Small.jsx": 61949,
	"./svg/files/AudioThumbnailSVG.jsx": 48953,
	"./svg/files/CSVSVG.jsx": 62341,
	"./svg/files/JSONFILESVG.jsx": 14036,
	"./svg/files/JSONSVG.jsx": 49742,
	"./svg/files/OtherFileTypeThumbnailSVG.jsx": 20299,
	"./svg/files/PDFFILESVG.jsx": 86252,
	"./svg/files/POFILESVG.jsx": 10743,
	"./svg/files/POSVG.jsx": 17044,
	"./svg/files/VideoThumbnailSVG.jsx": 7720,
	"./svg/files/XLIFFSVG.jsx": 31692,
	"./svg/files/XLMSVG.jsx": 44899,
	"./svg/files/XLSSVG.jsx": 36086,
	"./svg/files/XLSXFILESVG.jsx": 89048,
	"./svg/inviteMember/InviteMemberNoEmailSVG.jsx": 31491,
	"./svg/localization/EmptyProjectSVG.jsx": 40205,
	"./svg/localization/ImportLocalizationDropSVG.jsx": 54034,
	"./svg/localization/ImportLocalizationFileSVG.jsx": 48173,
	"./svg/localization/ImportSVG.jsx": 52757,
	"./svg/localization/PathSVG.jsx": 65722,
	"./svg/localization/TMStatusAprrovedSVG.jsx": 86362,
	"./svg/localization/TMStatusNotAprrovedSVG.jsx": 69928,
	"./svg/localization/TMStatusSVG.jsx": 28650,
	"./svg/localization/TMToolTipPreviewSVG.jsx": 53983,
	"./svg/payment/AmexSVG.jsx": 36001,
	"./svg/payment/CardSecuredSVG.jsx": 66516,
	"./svg/payment/ChangeSubscriptionContactSVG.jsx": 24614,
	"./svg/payment/CreditMethodSVG.jsx": 20098,
	"./svg/payment/EnterprisePlanSVG.jsx": 70721,
	"./svg/payment/EssentialPlanSVG.jsx": 28053,
	"./svg/payment/ExtraRecordSVG.jsx": 41009,
	"./svg/payment/FreePlanSVG.jsx": 15386,
	"./svg/payment/Horizontal3DotsSVG.jsx": 71086,
	"./svg/payment/InvoiceMethodSVG.jsx": 44848,
	"./svg/payment/LitePlanSVG.jsx": 21119,
	"./svg/payment/MasterSVG.jsx": 9514,
	"./svg/payment/OverlimitSVG.jsx": 26992,
	"./svg/payment/PlanIconSVG.jsx": 1408,
	"./svg/payment/ProfessionalPlanSVG.jsx": 35138,
	"./svg/payment/RocketSVG.jsx": 66552,
	"./svg/payment/UpgradeSVG.jsx": 91292,
	"./svg/payment/VisaSVG.jsx": 83126,
	"./svg/payment/cards/MasterSVG.jsx": 37431,
	"./svg/payment/cards/VisaSVG.jsx": 50929,
	"./svg/payment/illusttration/Limit.jsx": 42598,
	"./svg/payment/illusttration/LocaleBannerSVG.jsx": 77913,
	"./svg/payment/illusttration/TMBannerSVG.jsx": 72614,
	"./svg/priority/CriticalSVG.jsx": 73488,
	"./svg/priority/HighSVG.jsx": 21976,
	"./svg/priority/LowSVG.jsx": 26514,
	"./svg/priority/MediumSVG.jsx": 99937,
	"./svg/socials/TwitterSVG.jsx": 61943,
	"./svg/versionControl/AddColumnSVG.jsx": 3754,
	"./svg/versionControl/AddIconSVG.jsx": 52537,
	"./svg/versionControl/AddRecordSVG.jsx": 92199,
	"./svg/versionControl/BranchCreatedSVG.jsx": 64537,
	"./svg/versionControl/BranchTreeSVG.jsx": 94481,
	"./svg/versionControl/ChangedFromToSVG.jsx": 88154,
	"./svg/versionControl/ConflictSVG.jsx": 90564,
	"./svg/versionControl/CreateBranchSVG.jsx": 9920,
	"./svg/versionControl/DeleteIconSVG.jsx": 88436,
	"./svg/versionControl/DeleteRecordSVG.jsx": 29957,
	"./svg/versionControl/EditIconSVG.jsx": 6426,
	"./svg/versionControl/MasterBranchIllustrationSVG.jsx": 85975,
	"./svg/versionControl/MergedFromSVG.jsx": 92698,
	"./svg/versionControl/MergedSVG.jsx": 70072,
	"./svg/versionControl/MergedToParentSVG.jsx": 96194,
	"./svg/versionControl/NoDiffCheck.jsx": 65674,
	"./svg/versionControl/OverrideRecordSVG.jsx": 41224,
	"./svg/versionControl/UpdateColumnSVG.jsx": 7789,
	"./svg/versionControl/UpdateFromParentSVG.jsx": 73151,
	"./svg/versionControl/UpdateRecordSVG.jsx": 73585,
	"./svg/versionControl/VersionControlBannerSVG.jsx": 33582,
	"./svg/versionControl/VersionHistorySVG.jsx": 87844,
	"./svg/webHook/AddCommentSVG.jsx": 2716,
	"./svg/webHook/AmazonComprehendSVG.jsx": 16166,
	"./svg/webHook/AmazonTextToSpeechSVG.jsx": 42266,
	"./svg/webHook/AmazonTranslateSVG.jsx": 51473,
	"./svg/webHook/AutomationConditionSVG.jsx": 33058,
	"./svg/webHook/AutomationLogoSVG.jsx": 34444,
	"./svg/webHook/AutomationSVG.jsx": 88270,
	"./svg/webHook/AutomationSetSVG.jsx": 21575,
	"./svg/webHook/AutomationsEmptySVG.jsx": 52648,
	"./svg/webHook/BitbucketSVG.jsx": 63816,
	"./svg/webHook/GoogleOCRSVG.jsx": 44929,
	"./svg/webHook/GoogleTranslateSVG.jsx": 63393,
	"./svg/webHook/JiraBugSVG.jsx": 58102,
	"./svg/webHook/JiraSVG.jsx": 16249,
	"./svg/webHook/JiraStorySVG.jsx": 5323,
	"./svg/webHook/JiraTaskSVG.jsx": 53297,
	"./svg/webHook/LogoSVG.jsx": 73625,
	"./svg/webHook/ManualTriggerSVG.jsx": 12911,
	"./svg/webHook/ReopenCommentSVG.jsx": 20699,
	"./svg/webHook/ResolveCommentSVG.jsx": 61641,
	"./svg/webHook/RunSVG.jsx": 1541,
	"./svg/webHook/SlackSVG.jsx": 75893,
	"./svg/webHook/WebRequestSVG.jsx": 106,
	"./svg/workspace/InfoIconSVG.jsx": 64387,
	"assets/images/svg/AToZSVG.jsx": 71309,
	"assets/images/svg/AccessViewContainerSVG.jsx": 4909,
	"assets/images/svg/AccessViewSVG.jsx": 49336,
	"assets/images/svg/ActivateMemberSVG.jsx": 20904,
	"assets/images/svg/ActivateTmSVG.jsx": 95488,
	"assets/images/svg/ActivatedSVG.jsx": 62656,
	"assets/images/svg/AddAccessViewSVG.jsx": 26570,
	"assets/images/svg/AddAnotherMemberSVG.jsx": 92877,
	"assets/images/svg/AddCarretRightSVG.jsx": 45583,
	"assets/images/svg/AddColumnLeftSVG.jsx": 67957,
	"assets/images/svg/AddColumnRightSVG.jsx": 98356,
	"assets/images/svg/AddColumnSVG.jsx": 84848,
	"assets/images/svg/AddCommentSVG.jsx": 67603,
	"assets/images/svg/AddIconLQASVG.jsx": 95277,
	"assets/images/svg/AddIconSVG.jsx": 6155,
	"assets/images/svg/AddIconSVGFilled.jsx": 19790,
	"assets/images/svg/AddRecordAboveSVG.jsx": 31289,
	"assets/images/svg/AddRowBelowSVG.jsx": 3649,
	"assets/images/svg/AddUserViewSVG.jsx": 14544,
	"assets/images/svg/AddWorkspaceSVG.jsx": 68897,
	"assets/images/svg/AddonSVG.jsx": 62400,
	"assets/images/svg/AnchorLeft.jsx": 23197,
	"assets/images/svg/ApiStatusSVG.jsx": 91372,
	"assets/images/svg/ApplyIconSVG.jsx": 42309,
	"assets/images/svg/ArrowBackSVG.jsx": 60925,
	"assets/images/svg/ArrowDownSVG.jsx": 78678,
	"assets/images/svg/ArrowKeyDownSVG.jsx": 4035,
	"assets/images/svg/ArrowKeyUpSVG.jsx": 79100,
	"assets/images/svg/ArrowLeft2SVG.jsx": 5590,
	"assets/images/svg/ArrowLeftSVG.jsx": 52083,
	"assets/images/svg/ArrowMoveDownSVG.jsx": 78490,
	"assets/images/svg/ArrowMoveUpSVG.jsx": 30138,
	"assets/images/svg/ArrowNextSVG.jsx": 37660,
	"assets/images/svg/ArrowRightSVG.jsx": 14164,
	"assets/images/svg/ArrowUpSVG.jsx": 53761,
	"assets/images/svg/AudioNextSVG.jsx": 95846,
	"assets/images/svg/AudioPlaySVG.jsx": 18308,
	"assets/images/svg/AudioPrevSVG.jsx": 6812,
	"assets/images/svg/AudioSongSVG.jsx": 66864,
	"assets/images/svg/AuthyAuthSVG.jsx": 90588,
	"assets/images/svg/AutoQASVG.jsx": 45092,
	"assets/images/svg/AutoQASVG2.jsx": 26202,
	"assets/images/svg/AutomationTriggerSVG.jsx": 20765,
	"assets/images/svg/AvatarIconSVG.jsx": 71235,
	"assets/images/svg/BackButtonSVG.jsx": 50404,
	"assets/images/svg/BackIOSSVG.jsx": 83792,
	"assets/images/svg/BackgroundLoginSVG.jsx": 94173,
	"assets/images/svg/BlockQuoteSVG.jsx": 32452,
	"assets/images/svg/BoldSVG.jsx": 98969,
	"assets/images/svg/BranchSVG.jsx": 62734,
	"assets/images/svg/BugIconSVG.jsx": 74858,
	"assets/images/svg/BulletList.jsx": 49635,
	"assets/images/svg/CannotEditSVG.jsx": 14853,
	"assets/images/svg/CaseSensitiveSVG.jsx": 31821,
	"assets/images/svg/CellDiffSVG.jsx": 99868,
	"assets/images/svg/CellPreviewSVG.jsx": 57851,
	"assets/images/svg/ChairSVG.jsx": 79193,
	"assets/images/svg/ChatSVG.jsx": 25691,
	"assets/images/svg/CheckIconSVG.jsx": 30092,
	"assets/images/svg/CheckedBoolean.jsx": 10733,
	"assets/images/svg/CheckedContainerSVG.jsx": 4267,
	"assets/images/svg/CheckedSVG.jsx": 75337,
	"assets/images/svg/ChromeNotifySVG.jsx": 10454,
	"assets/images/svg/CircleAddIconSVG.jsx": 37062,
	"assets/images/svg/CircleCheckSVG.jsx": 20855,
	"assets/images/svg/CleanSVG.jsx": 32350,
	"assets/images/svg/CloseFolderSVG.jsx": 64109,
	"assets/images/svg/CloseIconSVG.jsx": 67444,
	"assets/images/svg/CloudsSVG.jsx": 81894,
	"assets/images/svg/CodeSVG.jsx": 15428,
	"assets/images/svg/CodingSVG.jsx": 77091,
	"assets/images/svg/ColorAddSVG.jsx": 13223,
	"assets/images/svg/ColorBucketSVG.jsx": 35360,
	"assets/images/svg/ColorCloseCircleSVG.jsx": 45211,
	"assets/images/svg/ColorCloseSVG.jsx": 58536,
	"assets/images/svg/ColorStickerSVG.jsx": 31846,
	"assets/images/svg/ColumnPermissionSVG.jsx": 52450,
	"assets/images/svg/ComingSoonSVG.jsx": 64890,
	"assets/images/svg/CommentEmojiIconSVG.jsx": 15945,
	"assets/images/svg/CommentNotFoundSVG.jsx": 82754,
	"assets/images/svg/CommentNotifySVG.jsx": 61051,
	"assets/images/svg/CommentReOpenSVG.jsx": 63435,
	"assets/images/svg/CommentResolvedSVG.jsx": 43700,
	"assets/images/svg/CommentsSVG.jsx": 52488,
	"assets/images/svg/CompanyGroupTutorialSVG.jsx": 75924,
	"assets/images/svg/CompanySVG.jsx": 95272,
	"assets/images/svg/ConnectorSVG.jsx": 5256,
	"assets/images/svg/ConnectorSidebarSVG.jsx": 94065,
	"assets/images/svg/CopySourceSVG.jsx": 86198,
	"assets/images/svg/CustomSVG.jsx": 6710,
	"assets/images/svg/DatabaseEmptySVG.jsx": 85347,
	"assets/images/svg/DatabaseSVG.jsx": 94517,
	"assets/images/svg/DeactivateMemberSVG.jsx": 10787,
	"assets/images/svg/DeactivateTmSVG.jsx": 18921,
	"assets/images/svg/DefaultSystemItemSVG.jsx": 85527,
	"assets/images/svg/DeleteAvailableRecordSVG.jsx": 9564,
	"assets/images/svg/DeleteSVG.jsx": 84183,
	"assets/images/svg/DependencySVG.jsx": 13208,
	"assets/images/svg/DoneSVG.jsx": 33154,
	"assets/images/svg/DownloadSVG.jsx": 27777,
	"assets/images/svg/DraggingSVG.jsx": 6636,
	"assets/images/svg/DropdownSVG.jsx": 58938,
	"assets/images/svg/DuplicateSVG.jsx": 54917,
	"assets/images/svg/EditGroupSVG.jsx": 71478,
	"assets/images/svg/EditPaperSVG.jsx": 4394,
	"assets/images/svg/EditSVG.jsx": 51542,
	"assets/images/svg/ElsaSVG.jsx": 23277,
	"assets/images/svg/EmptyBoxSVG.jsx": 3236,
	"assets/images/svg/EmptyGridSVG.jsx": 16499,
	"assets/images/svg/EmptyGroupAccessSVG.jsx": 99425,
	"assets/images/svg/EmptyGroupMembersSVG.jsx": 98590,
	"assets/images/svg/ErrorIconSVG.jsx": 53081,
	"assets/images/svg/ErrorSVG.jsx": 63363,
	"assets/images/svg/ExcelSVG.jsx": 88163,
	"assets/images/svg/ExclaimationMarkSVG.jsx": 3392,
	"assets/images/svg/ExpandRecordSVG.jsx": 40700,
	"assets/images/svg/ExpandSVG.jsx": 73932,
	"assets/images/svg/ExportJsonSVG.jsx": 96162,
	"assets/images/svg/ExportSVG.jsx": 10513,
	"assets/images/svg/ExtendViewSVG.jsx": 94329,
	"assets/images/svg/EyeCloseIconSVG.jsx": 20665,
	"assets/images/svg/EyeOpenIconSVG.jsx": 90481,
	"assets/images/svg/FileSVG.jsx": 64652,
	"assets/images/svg/FillStarSVG.jsx": 55288,
	"assets/images/svg/FilterSVG.jsx": 58143,
	"assets/images/svg/FlightSVG.jsx": 80998,
	"assets/images/svg/FolderUploadSVG.jsx": 49749,
	"assets/images/svg/FormulaSVG.jsx": 83480,
	"assets/images/svg/FreeTrialBannerSVG.jsx": 29097,
	"assets/images/svg/FullAPIDocSVG.jsx": 45533,
	"assets/images/svg/GeneralSettingSVG.jsx": 35478,
	"assets/images/svg/GetStartedBkgSVG.jsx": 68390,
	"assets/images/svg/GlobalUniqueRecordIdSVG.jsx": 60735,
	"assets/images/svg/GoogleAuthSVG.jsx": 31416,
	"assets/images/svg/GoogleCalendarSVG.jsx": 20102,
	"assets/images/svg/GoogleLoginSVG.jsx": 68031,
	"assets/images/svg/GoogleSheetSVG.jsx": 30723,
	"assets/images/svg/GridContainerSVG.jsx": 84780,
	"assets/images/svg/GridIconSVG.jsx": 53622,
	"assets/images/svg/GridListEmptySVG.jsx": 49624,
	"assets/images/svg/GridSVG.jsx": 76902,
	"assets/images/svg/GridTMSVG.jsx": 74493,
	"assets/images/svg/GridTablePreviewSVG.jsx": 47794,
	"assets/images/svg/H1IconSVG.jsx": 10482,
	"assets/images/svg/H2IconSVG.jsx": 74555,
	"assets/images/svg/H3IconSVG.jsx": 34562,
	"assets/images/svg/HambergerMenuSVG.jsx": 29830,
	"assets/images/svg/HashSymbolSVG.jsx": 53893,
	"assets/images/svg/HelpCircleSVG.jsx": 87188,
	"assets/images/svg/HelpSVG.jsx": 90761,
	"assets/images/svg/HelpSquareSVG.jsx": 46587,
	"assets/images/svg/HistorySVG.jsx": 4861,
	"assets/images/svg/HistorySVG2.jsx": 80713,
	"assets/images/svg/IconAddMemberSVG.jsx": 26933,
	"assets/images/svg/IconAdminUserSVG.jsx": 94176,
	"assets/images/svg/IconCameraSVG.jsx": 80790,
	"assets/images/svg/IconCaretDownSVG.jsx": 31604,
	"assets/images/svg/IconCaretRightSVG.jsx": 60739,
	"assets/images/svg/IconCopySVG.jsx": 71025,
	"assets/images/svg/IconDirectionRightSVG.jsx": 56804,
	"assets/images/svg/IconFullAccessSVG.jsx": 3699,
	"assets/images/svg/IconGridlySVG.jsx": 27707,
	"assets/images/svg/IconImageSVG.jsx": 8825,
	"assets/images/svg/IconLimitAccessSVG.jsx": 60858,
	"assets/images/svg/IconListSVG.jsx": 94704,
	"assets/images/svg/IconLockSVG.jsx": 61270,
	"assets/images/svg/IconMoreActionsSVG.jsx": 24184,
	"assets/images/svg/IconTMSettingSVG.jsx": 31714,
	"assets/images/svg/IconTMXFileSVG.jsx": 12176,
	"assets/images/svg/IconTableSVG.jsx": 29664,
	"assets/images/svg/IconUploadFileSVG.jsx": 25403,
	"assets/images/svg/IdentifySVG.jsx": 32146,
	"assets/images/svg/IgnoreSameSVG.jsx": 99702,
	"assets/images/svg/IgnoreSingleSVG.jsx": 22987,
	"assets/images/svg/ImageSlideShowSVG.jsx": 91943,
	"assets/images/svg/ImportFileSVG.jsx": 84566,
	"assets/images/svg/ImportSVG.jsx": 68967,
	"assets/images/svg/InfoContainedIconSVG.jsx": 70232,
	"assets/images/svg/InfoIconSVG.jsx": 96635,
	"assets/images/svg/InternalManagerSVG.jsx": 65281,
	"assets/images/svg/InternalUserSVG.jsx": 96189,
	"assets/images/svg/InviteCompanySVG.jsx": 66734,
	"assets/images/svg/InviteMemberSuccessSVG.jsx": 35639,
	"assets/images/svg/ItalicSVG.jsx": 83376,
	"assets/images/svg/JsonFileSVG.jsx": 85614,
	"assets/images/svg/KeyboardSVG.jsx": 18976,
	"assets/images/svg/KickoutSVG.jsx": 48412,
	"assets/images/svg/LQAContainerSVG.jsx": 51797,
	"assets/images/svg/LQAIconSVG.jsx": 54851,
	"assets/images/svg/LQAIssueTypeSVG.jsx": 40317,
	"assets/images/svg/LQASVG.jsx": 39600,
	"assets/images/svg/LQASettingSVG.jsx": 54420,
	"assets/images/svg/LQAStatusChangeSVG.jsx": 20097,
	"assets/images/svg/LQAViewSVG.jsx": 37287,
	"assets/images/svg/LambdaSVG.jsx": 35510,
	"assets/images/svg/LeftBushSVG.jsx": 46982,
	"assets/images/svg/LicenseSVG.jsx": 71301,
	"assets/images/svg/LinkIconSVG.jsx": 85643,
	"assets/images/svg/LinkSVG copy.jsx": 99428,
	"assets/images/svg/LinkSVG.jsx": 2017,
	"assets/images/svg/LoadingMonsterSVG.jsx": 81911,
	"assets/images/svg/LogoGridUISVG.jsx": 99625,
	"assets/images/svg/LogoGridlySVG.jsx": 99250,
	"assets/images/svg/LogoutSVG.jsx": 24555,
	"assets/images/svg/MagicWandSVG.jsx": 75775,
	"assets/images/svg/MailgunSVG.jsx": 70353,
	"assets/images/svg/MaintenanceSVG.jsx": 62098,
	"assets/images/svg/MediumSVG.jsx": 1441,
	"assets/images/svg/MemsourceSVG.jsx": 16412,
	"assets/images/svg/MicrosoftAuthSVG.jsx": 85098,
	"assets/images/svg/MultiStepIllustratorSVG.jsx": 95856,
	"assets/images/svg/MultipleRowSVG.jsx": 84262,
	"assets/images/svg/MySqlSVG.jsx": 66283,
	"assets/images/svg/NewTMSVG.jsx": 96227,
	"assets/images/svg/NewVersionNotifySVG.jsx": 47983,
	"assets/images/svg/NextButtonSVG.jsx": 59696,
	"assets/images/svg/NoAccessSVG.jsx": 88718,
	"assets/images/svg/NoPathTagSVG.jsx": 67069,
	"assets/images/svg/NoShareViewGroupSVG.jsx": 46275,
	"assets/images/svg/NoSourceIllustratorSVG.jsx": 80118,
	"assets/images/svg/NoTranslationOverviewSVG.jsx": 70933,
	"assets/images/svg/NoTreeItemSVG.jsx": 48464,
	"assets/images/svg/NonBreakingSpaceSVG.jsx": 71786,
	"assets/images/svg/NormalFIlterModeSVG.jsx": 93173,
	"assets/images/svg/NormalSortSVG.jsx": 14293,
	"assets/images/svg/NotFoundBoxSVG.jsx": 46763,
	"assets/images/svg/NotFoundIllustrationSVG.jsx": 25397,
	"assets/images/svg/NotificationSVG.jsx": 62466,
	"assets/images/svg/NumberList.jsx": 3162,
	"assets/images/svg/OpenFolderSVG.jsx": 49414,
	"assets/images/svg/OpenNewPageSVG.jsx": 59789,
	"assets/images/svg/OrganizationSetttingSVG.jsx": 50328,
	"assets/images/svg/OutlineStarSVG.jsx": 3630,
	"assets/images/svg/ParagraphSVG.jsx": 60831,
	"assets/images/svg/PartialCheckedBoolean.jsx": 20783,
	"assets/images/svg/PathTagSVG.jsx": 39750,
	"assets/images/svg/PauseContained2SVG.jsx": 70339,
	"assets/images/svg/PauseContainedSVG.jsx": 12159,
	"assets/images/svg/PauseSVG.jsx": 84280,
	"assets/images/svg/PercentageSymbolSVG.jsx": 83633,
	"assets/images/svg/PinSVG.jsx": 29131,
	"assets/images/svg/PlayCircleSVG.jsx": 4515,
	"assets/images/svg/PlayContainedSVG.jsx": 68271,
	"assets/images/svg/PlayOutlinedSVG.jsx": 85540,
	"assets/images/svg/PlaySVG.jsx": 18520,
	"assets/images/svg/PostgresSVG.jsx": 5052,
	"assets/images/svg/PreviewCellSVG.jsx": 63959,
	"assets/images/svg/PreviewSVG.jsx": 76896,
	"assets/images/svg/PrivacyPolicySVG.jsx": 23221,
	"assets/images/svg/ProjectAboutSVG.jsx": 44882,
	"assets/images/svg/ProjectMemberSVG.jsx": 6323,
	"assets/images/svg/ProjectUsageSVG.jsx": 19857,
	"assets/images/svg/QuestionSVG.jsx": 96425,
	"assets/images/svg/QuickApplyTmSVG.jsx": 4737,
	"assets/images/svg/QuickFilterSVG.jsx": 69853,
	"assets/images/svg/RecordPanelEmptyRecordSVG.jsx": 25103,
	"assets/images/svg/RedoSVG.jsx": 75626,
	"assets/images/svg/RefreshSVG.jsx": 44344,
	"assets/images/svg/RegexSVG.jsx": 49934,
	"assets/images/svg/RemoveSVG.jsx": 27910,
	"assets/images/svg/RemoveTagSVG.jsx": 42112,
	"assets/images/svg/RepeatSVG.jsx": 95829,
	"assets/images/svg/ReplaceSVG.jsx": 21649,
	"assets/images/svg/ResendInvitationSVG.jsx": 23287,
	"assets/images/svg/RevertSVG.jsx": 29472,
	"assets/images/svg/RevokeSVG.jsx": 75354,
	"assets/images/svg/RowHeightSVG.jsx": 97609,
	"assets/images/svg/SamlLoginSVG.jsx": 32633,
	"assets/images/svg/SaveSVG.jsx": 45742,
	"assets/images/svg/SearchSVG.jsx": 30130,
	"assets/images/svg/SecuritySVG.jsx": 47305,
	"assets/images/svg/SendCommentSVG.jsx": 7604,
	"assets/images/svg/SettingBillingSVG.jsx": 6750,
	"assets/images/svg/SettingGroupSVG.jsx": 8197,
	"assets/images/svg/SettingInfoSVG.jsx": 23148,
	"assets/images/svg/SettingMemberSVG.jsx": 29158,
	"assets/images/svg/SettingPaymentSVG.jsx": 29200,
	"assets/images/svg/SettingRoleSVG.jsx": 49194,
	"assets/images/svg/SettingSVG.jsx": 10143,
	"assets/images/svg/SettingStatisticSVG.jsx": 80686,
	"assets/images/svg/ShareLinkOptionSVG.jsx": 66282,
	"assets/images/svg/ShareLinkViewIlluSVG.jsx": 77010,
	"assets/images/svg/ShareSVG.jsx": 80862,
	"assets/images/svg/SharedUserViewSVG.jsx": 38481,
	"assets/images/svg/ShieldSVG.jsx": 32729,
	"assets/images/svg/ShortSVG.jsx": 52732,
	"assets/images/svg/ShowAllConflictsSVG.jsx": 9826,
	"assets/images/svg/ShowSpecialCharacterSVG.jsx": 2839,
	"assets/images/svg/ShuffleSVG.jsx": 1147,
	"assets/images/svg/SinglePathTagSVG.jsx": 79512,
	"assets/images/svg/SingleRowSVG.jsx": 65989,
	"assets/images/svg/SleepBellSVG.jsx": 14449,
	"assets/images/svg/SmileFaceSVG.jsx": 59120,
	"assets/images/svg/SortAscendingSVG.jsx": 15163,
	"assets/images/svg/SortDescendingSVG.jsx": 85541,
	"assets/images/svg/SortFilterSVG.jsx": 40183,
	"assets/images/svg/SpeakerSVG.jsx": 86703,
	"assets/images/svg/SrSpSVG.jsx": 16656,
	"assets/images/svg/StrikethroughSVG.jsx": 28893,
	"assets/images/svg/SubtractSVG.jsx": 81573,
	"assets/images/svg/SuccessIconSVG.jsx": 19276,
	"assets/images/svg/SupportAgentSVG.jsx": 28835,
	"assets/images/svg/SwapSVG.jsx": 91507,
	"assets/images/svg/SwitchIconSVG.jsx": 21989,
	"assets/images/svg/SwitchSVG.jsx": 77686,
	"assets/images/svg/Sync2SVG.jsx": 67104,
	"assets/images/svg/SyncConnectionIllustratorSVG.jsx": 41195,
	"assets/images/svg/SyncSVG.jsx": 47598,
	"assets/images/svg/SynchronizeTMColorSVG.jsx": 67454,
	"assets/images/svg/SynchronizeTMPullSVG.jsx": 91955,
	"assets/images/svg/SynchronizeTMPushSVG.jsx": 63200,
	"assets/images/svg/SynchronizeTMSVG.jsx": 89542,
	"assets/images/svg/SystemGroupSVG.jsx": 75755,
	"assets/images/svg/TBIconSVG.jsx": 42634,
	"assets/images/svg/TBSettingSVG.jsx": 80840,
	"assets/images/svg/TMGuideSVG.jsx": 4314,
	"assets/images/svg/TMIconSVG.jsx": 65933,
	"assets/images/svg/TMSVG.jsx": 58369,
	"assets/images/svg/TMSearchNotFoundSVG.jsx": 49032,
	"assets/images/svg/TMSettingSVG.jsx": 4804,
	"assets/images/svg/TagSVG.jsx": 82600,
	"assets/images/svg/TallSVG.jsx": 46514,
	"assets/images/svg/TemplateSVG.jsx": 55103,
	"assets/images/svg/TextColorSVG.jsx": 90019,
	"assets/images/svg/TextSVG.jsx": 69638,
	"assets/images/svg/TransferInternalSVG.jsx": 26438,
	"assets/images/svg/TransformOwnerShipSVG.jsx": 44993,
	"assets/images/svg/TransformSVG.jsx": 48943,
	"assets/images/svg/TranslationMemorySVG.jsx": 2644,
	"assets/images/svg/TutorialSVG.jsx": 70198,
	"assets/images/svg/UnCheckSVG.jsx": 36356,
	"assets/images/svg/UncheckedBoolean.jsx": 31202,
	"assets/images/svg/UnderlineSVG.jsx": 28710,
	"assets/images/svg/UndoSVG.jsx": 11477,
	"assets/images/svg/UniquePathtagRecordIdSVG.jsx": 41974,
	"assets/images/svg/UnstableSVG.jsx": 63616,
	"assets/images/svg/UpdateIconSVG.jsx": 44118,
	"assets/images/svg/UpdateJsonSVG.jsx": 59599,
	"assets/images/svg/UploadFileSVG.jsx": 64038,
	"assets/images/svg/UploadFromCloudSVG.jsx": 31498,
	"assets/images/svg/UploadingDoneSVG.jsx": 71483,
	"assets/images/svg/UploadingErrorSVG.jsx": 8241,
	"assets/images/svg/UserIconSVG.jsx": 9120,
	"assets/images/svg/UserPlusSVG.jsx": 15525,
	"assets/images/svg/UserViewSVG.jsx": 52139,
	"assets/images/svg/VideoPlaySVG.jsx": 24048,
	"assets/images/svg/WarningRoundSVG.jsx": 26837,
	"assets/images/svg/WarningSVG.jsx": 823,
	"assets/images/svg/WarningSwitchingColumnSVG.jsx": 79718,
	"assets/images/svg/WelcomeBoySVG.jsx": 98478,
	"assets/images/svg/WelcomeGirlSVG.jsx": 4093,
	"assets/images/svg/WelcomeIconSVG.jsx": 72617,
	"assets/images/svg/WelcomePlaySVG.jsx": 12691,
	"assets/images/svg/WhatNewSVG.jsx": 51859,
	"assets/images/svg/WorkspaceEmptySVG.jsx": 94926,
	"assets/images/svg/WorkspaceSVG.jsx": 72124,
	"assets/images/svg/WraptextSVG.jsx": 2619,
	"assets/images/svg/YAYSVG.jsx": 39481,
	"assets/images/svg/ZToASVG.jsx": 8846,
	"assets/images/svg/ZapierSVG.jsx": 66954,
	"assets/images/svg/addon/AddButtonContainerSVG.jsx": 90680,
	"assets/images/svg/addon/AutomationActionSVG.jsx": 99245,
	"assets/images/svg/addon/CurrentLQASVG.jsx": 20355,
	"assets/images/svg/addon/GridlyShortLogoSVG.jsx": 1577,
	"assets/images/svg/addon/LQASVG.jsx": 25670,
	"assets/images/svg/addon/LQAStep2SVG.jsx": 30848,
	"assets/images/svg/addon/MemSourceGridlySVG.jsx": 79265,
	"assets/images/svg/addon/MemSourceSVG.jsx": 91333,
	"assets/images/svg/addon/MemoQGridlySVG.jsx": 20613,
	"assets/images/svg/addon/MemoQSVG.jsx": 98816,
	"assets/images/svg/addon/NoFoundSVG.jsx": 40335,
	"assets/images/svg/addon/SettingSVG.jsx": 93229,
	"assets/images/svg/addon/TranslationOverviewSVG.jsx": 93300,
	"assets/images/svg/apiKeys/FullAccessSVG.jsx": 73791,
	"assets/images/svg/apiKeys/NotFoundSVG.jsx": 26506,
	"assets/images/svg/apiKeys/PartialAccessSVG.jsx": 73666,
	"assets/images/svg/backup/NoBackupFileSVG.jsx": 49798,
	"assets/images/svg/censors/VersionControlLightSVG.jsx": 14970,
	"assets/images/svg/censors/VersionControlSVG.jsx": 86805,
	"assets/images/svg/dependencies/ApproveSVG.jsx": 91079,
	"assets/images/svg/dependencies/SourceStatusSVG.jsx": 87353,
	"assets/images/svg/dependencies/StringTypeSVG.jsx": 43920,
	"assets/images/svg/dependencies/column/normal/DoNotTranslateSVG.jsx": 76782,
	"assets/images/svg/dependencies/column/normal/EmptySVG.jsx": 64238,
	"assets/images/svg/dependencies/column/normal/LockedSVG.jsx": 9588,
	"assets/images/svg/dependencies/column/normal/NotReadyForTranslateSVG.jsx": 15849,
	"assets/images/svg/dependencies/column/normal/ReadyForTranslateSVG.jsx": 99744,
	"assets/images/svg/diff/Minus.jsx": 42109,
	"assets/images/svg/diff/Plus.jsx": 72156,
	"assets/images/svg/extendViews/Large.jsx": 62612,
	"assets/images/svg/extendViews/Medium.jsx": 18097,
	"assets/images/svg/extendViews/Small.jsx": 61949,
	"assets/images/svg/files/AudioThumbnailSVG.jsx": 48953,
	"assets/images/svg/files/CSVSVG.jsx": 62341,
	"assets/images/svg/files/JSONFILESVG.jsx": 14036,
	"assets/images/svg/files/JSONSVG.jsx": 49742,
	"assets/images/svg/files/OtherFileTypeThumbnailSVG.jsx": 20299,
	"assets/images/svg/files/PDFFILESVG.jsx": 86252,
	"assets/images/svg/files/POFILESVG.jsx": 10743,
	"assets/images/svg/files/POSVG.jsx": 17044,
	"assets/images/svg/files/VideoThumbnailSVG.jsx": 7720,
	"assets/images/svg/files/XLIFFSVG.jsx": 31692,
	"assets/images/svg/files/XLMSVG.jsx": 44899,
	"assets/images/svg/files/XLSSVG.jsx": 36086,
	"assets/images/svg/files/XLSXFILESVG.jsx": 89048,
	"assets/images/svg/inviteMember/InviteMemberNoEmailSVG.jsx": 31491,
	"assets/images/svg/localization/EmptyProjectSVG.jsx": 40205,
	"assets/images/svg/localization/ImportLocalizationDropSVG.jsx": 54034,
	"assets/images/svg/localization/ImportLocalizationFileSVG.jsx": 48173,
	"assets/images/svg/localization/ImportSVG.jsx": 52757,
	"assets/images/svg/localization/PathSVG.jsx": 65722,
	"assets/images/svg/localization/TMStatusAprrovedSVG.jsx": 86362,
	"assets/images/svg/localization/TMStatusNotAprrovedSVG.jsx": 69928,
	"assets/images/svg/localization/TMStatusSVG.jsx": 28650,
	"assets/images/svg/localization/TMToolTipPreviewSVG.jsx": 53983,
	"assets/images/svg/payment/AmexSVG.jsx": 36001,
	"assets/images/svg/payment/CardSecuredSVG.jsx": 66516,
	"assets/images/svg/payment/ChangeSubscriptionContactSVG.jsx": 24614,
	"assets/images/svg/payment/CreditMethodSVG.jsx": 20098,
	"assets/images/svg/payment/EnterprisePlanSVG.jsx": 70721,
	"assets/images/svg/payment/EssentialPlanSVG.jsx": 28053,
	"assets/images/svg/payment/ExtraRecordSVG.jsx": 41009,
	"assets/images/svg/payment/FreePlanSVG.jsx": 15386,
	"assets/images/svg/payment/Horizontal3DotsSVG.jsx": 71086,
	"assets/images/svg/payment/InvoiceMethodSVG.jsx": 44848,
	"assets/images/svg/payment/LitePlanSVG.jsx": 21119,
	"assets/images/svg/payment/MasterSVG.jsx": 9514,
	"assets/images/svg/payment/OverlimitSVG.jsx": 26992,
	"assets/images/svg/payment/PlanIconSVG.jsx": 1408,
	"assets/images/svg/payment/ProfessionalPlanSVG.jsx": 35138,
	"assets/images/svg/payment/RocketSVG.jsx": 66552,
	"assets/images/svg/payment/UpgradeSVG.jsx": 91292,
	"assets/images/svg/payment/VisaSVG.jsx": 83126,
	"assets/images/svg/payment/cards/MasterSVG.jsx": 37431,
	"assets/images/svg/payment/cards/VisaSVG.jsx": 50929,
	"assets/images/svg/payment/illusttration/Limit.jsx": 42598,
	"assets/images/svg/payment/illusttration/LocaleBannerSVG.jsx": 77913,
	"assets/images/svg/payment/illusttration/TMBannerSVG.jsx": 72614,
	"assets/images/svg/priority/CriticalSVG.jsx": 73488,
	"assets/images/svg/priority/HighSVG.jsx": 21976,
	"assets/images/svg/priority/LowSVG.jsx": 26514,
	"assets/images/svg/priority/MediumSVG.jsx": 99937,
	"assets/images/svg/socials/TwitterSVG.jsx": 61943,
	"assets/images/svg/versionControl/AddColumnSVG.jsx": 3754,
	"assets/images/svg/versionControl/AddIconSVG.jsx": 52537,
	"assets/images/svg/versionControl/AddRecordSVG.jsx": 92199,
	"assets/images/svg/versionControl/BranchCreatedSVG.jsx": 64537,
	"assets/images/svg/versionControl/BranchTreeSVG.jsx": 94481,
	"assets/images/svg/versionControl/ChangedFromToSVG.jsx": 88154,
	"assets/images/svg/versionControl/ConflictSVG.jsx": 90564,
	"assets/images/svg/versionControl/CreateBranchSVG.jsx": 9920,
	"assets/images/svg/versionControl/DeleteIconSVG.jsx": 88436,
	"assets/images/svg/versionControl/DeleteRecordSVG.jsx": 29957,
	"assets/images/svg/versionControl/EditIconSVG.jsx": 6426,
	"assets/images/svg/versionControl/MasterBranchIllustrationSVG.jsx": 85975,
	"assets/images/svg/versionControl/MergedFromSVG.jsx": 92698,
	"assets/images/svg/versionControl/MergedSVG.jsx": 70072,
	"assets/images/svg/versionControl/MergedToParentSVG.jsx": 96194,
	"assets/images/svg/versionControl/NoDiffCheck.jsx": 65674,
	"assets/images/svg/versionControl/OverrideRecordSVG.jsx": 41224,
	"assets/images/svg/versionControl/UpdateColumnSVG.jsx": 7789,
	"assets/images/svg/versionControl/UpdateFromParentSVG.jsx": 73151,
	"assets/images/svg/versionControl/UpdateRecordSVG.jsx": 73585,
	"assets/images/svg/versionControl/VersionControlBannerSVG.jsx": 33582,
	"assets/images/svg/versionControl/VersionHistorySVG.jsx": 87844,
	"assets/images/svg/webHook/AddCommentSVG.jsx": 2716,
	"assets/images/svg/webHook/AmazonComprehendSVG.jsx": 16166,
	"assets/images/svg/webHook/AmazonTextToSpeechSVG.jsx": 42266,
	"assets/images/svg/webHook/AmazonTranslateSVG.jsx": 51473,
	"assets/images/svg/webHook/AutomationConditionSVG.jsx": 33058,
	"assets/images/svg/webHook/AutomationLogoSVG.jsx": 34444,
	"assets/images/svg/webHook/AutomationSVG.jsx": 88270,
	"assets/images/svg/webHook/AutomationSetSVG.jsx": 21575,
	"assets/images/svg/webHook/AutomationsEmptySVG.jsx": 52648,
	"assets/images/svg/webHook/BitbucketSVG.jsx": 63816,
	"assets/images/svg/webHook/GoogleOCRSVG.jsx": 44929,
	"assets/images/svg/webHook/GoogleTranslateSVG.jsx": 63393,
	"assets/images/svg/webHook/JiraBugSVG.jsx": 58102,
	"assets/images/svg/webHook/JiraSVG.jsx": 16249,
	"assets/images/svg/webHook/JiraStorySVG.jsx": 5323,
	"assets/images/svg/webHook/JiraTaskSVG.jsx": 53297,
	"assets/images/svg/webHook/LogoSVG.jsx": 73625,
	"assets/images/svg/webHook/ManualTriggerSVG.jsx": 12911,
	"assets/images/svg/webHook/ReopenCommentSVG.jsx": 20699,
	"assets/images/svg/webHook/ResolveCommentSVG.jsx": 61641,
	"assets/images/svg/webHook/RunSVG.jsx": 1541,
	"assets/images/svg/webHook/SlackSVG.jsx": 75893,
	"assets/images/svg/webHook/WebRequestSVG.jsx": 106,
	"assets/images/svg/workspace/InfoIconSVG.jsx": 64387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40197;